import { render } from "./Bottombar.vue?vue&type=template&id=6f23376d&scoped=true"
import script from "./Bottombar.vue?vue&type=script&lang=js"
export * from "./Bottombar.vue?vue&type=script&lang=js"

import "./Bottombar.vue?vue&type=style&index=0&id=6f23376d&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f23376d"]])

export default __exports__